import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Main from '@/views/main'
import Login from '@/views/login'
import SalerProducts from '@/views/salerviews/products'
import SalerOrders from '@/views/salerviews/myorder'
import SalerOrderDetail from '@/views/salerviews/orderdetail'
import SalerOrderCreate from '@/views/salerviews/createorder'
import SalerOrderEdit from '@/views/salerviews/editorder'

import CangkuSendorder from '@/views/cangkuviews/sendorder'
import CangkuSendorderDone from '@/views/cangkuviews/sendorderdone'



import CangkuSendOrderDetail from '@/views/cangkuviews/sendorderdetail'


import SucaiList from '@/views/sucaiview/sucailist'
import SucaiUpload from '@/views/sucaiview/sucaiupload'
import RukuList from '@/views/shangwuviews/rukulist'
import RukuAdd from '@/views/shangwuviews/rukuadd'
import ShangwuOrders from '@/views/shangwuviews/orders'
import ShangwuOrdersDetail from '@/views/shangwuviews/orderdetail'
import ShangwuClientView from '@/views/shangwuviews/clientview'
import ShangwuClientAdd from '@/views/shangwuviews/clientadd'

import SaleClientView from '@/views/salerviews/clientview'
import SaleClientAdd from '@/views/salerviews/clientadd'



Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
   {
	path: '/login',
	name: 'Login',
	component: Login
	  },
    {
		path: '/',
		name: 'Main',
		component: Main
	},
    {
      path: '/index',
      name: 'Main',
      component: Main
    },
    {
      path: '/salerviews/products',
      name: 'SalerProducts',
      component: SalerProducts
    },
	

    {
      path: '/salerviews/myorder',
      name: 'SalerOrders',
      component: SalerOrders
    },
    {
      path: '/salerviews/orderdetail',
      name: 'SalerOrderDetail',
      component: SalerOrderDetail
    },
    {
      path: '/salerviews/ordercreate',
      name: 'SalerOrderCreate',
      component: SalerOrderCreate
    },
    {
      path: '/cangkuviews/sendorder',
      name: 'CangkuSendorder',
      component: CangkuSendorder
    },
    {
      path: '/cangkuviews/sendorderdone',
      name: 'CangkuSendorderDone',
      component: CangkuSendorderDone
    },
    {
      path: '/cangkuviews/sendorderdetail',
      name: 'CangkuSendOrderDetail',
      component: CangkuSendOrderDetail
    },
    {
      path: '/salerviews/orderedit',
      name: 'SalerOrderEdit',
      component: SalerOrderEdit
    },

    {
      path: '/tongyong/sucailist',
      name: 'SucaiList',
      component: SucaiList
    },
    {
      path: '/tongyong/sucaiupload',
      name: 'SucaiUpload',
      component: SucaiUpload
    },
    {
      path: '/shangwuviews/rukulist',
      name: 'RukuList',
      component: RukuList
    },
    {
      path: '/shangwuviews/rukuadd',
      name: 'RukuAdd',
      component: RukuAdd
    },
    {
      path: '/shangwuviews/orders',
      name: 'ShangwuOrders',
      component: ShangwuOrders
    },
    {
      path: '/shangwuviews/ordersdetail',
      name: 'ShangwuOrdersDetail',
      component: ShangwuOrdersDetail
    },
    {
      path: '/shangwuviews/clientview',
      name: 'ShangwuClientView',
      component: ShangwuClientView
    },
    {
      path: '/shangwuviews/clientadd',
      name: 'ShangwuClientAdd',
      component: ShangwuClientAdd
    },
	
	{
	  path: '/salerviews/clientview',
	  name: 'SaleClientView',
	  component: SaleClientView
	},
	{
	  path: '/salerviews/clientadd',
	  name: 'SaleClientAdd',
	  component: SaleClientAdd
	},







  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js